import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { AbsColor } from '../../constants';

interface InspectionRiskLabelProps {
    month1Ref: any;
    checkListRef: any;
    heightSize: number;
}

const PSCInspectionRiskLabel = ({ month1Ref, checkListRef, heightSize: height }: InspectionRiskLabelProps) => {
    const [size, setSize] = useState<number>();
    const [left, setLeft] = useState<number>();

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        handleResize();
    }, [window.innerWidth, month1Ref.current?.getBoundingClientRect(), checkListRef.current?.getBoundingClientRect()]);

    const handleResize = () => {
        const leftCoordinate = month1Ref.current.getBoundingClientRect().left;
        const rightCoordinate = checkListRef.current.getBoundingClientRect().left;
        setLeft(leftCoordinate);
        setSize(rightCoordinate - leftCoordinate);
    };

    return (
        <div style={{ height: height }}>
            <Box
                sx={{
                    backgroundColor: AbsColor.Blue1,
                    color: AbsColor.White1,
                    padding: '20px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: size,
                    height: 10,
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                    position: 'absolute',
                    left: left
                }}
            >
                <Typography variant="h6" align="center" style={{ color: AbsColor.White1, fontWeight: 'bold' }}>
                    Inspection Risk
                </Typography>
            </Box>
        </div>
    );
};

export default PSCInspectionRiskLabel;
